// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"427":"a9dfc181","511":"a32337fb","548":"739f974f","720":"fdce9265","817":"15b886e2"}[chunkId] + ".chunk.js";
};